
<div class="flex flex-col gap-6 min-w-[30vw] min-h-40">
  <div class="w-full flex flex-col gap-6 ">
    @if (!!localData) {
      <div class="flex gap-4 items-center">
        <div class="flex flex-col gap-2 w-full">
          <label class="font-semibold">Unit
            @if (!localData.unitId) {
              <span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span>
            }
          </label>
          <p-select panelStyleClass="text-surface-800 text-sm"
                    [options]="availableUnits()"
                    [ngModel]="findUnit(localData.unitId)"
                    (onChange)="updateLinkedUnit($event)"
                    placeholder="Select..."
                    [showClear]="true"
                    [filter]="true"
                    filterBy="code,name"
                    filterPlaceholder="Type to search units..."
                    fluid
                    required
                    appendTo="body"
                    optionLabel="name"
                    [disabled]="!!localData.unitId"
          >
            <ng-template #selectedItem let-unit >
              {{unit.code + ": " + unit.name}}
            </ng-template>
            <ng-template #item let-unit >
              {{unit.code + ": " + unit.name}}
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="flex items-end gap-2">
        <div class="flex flex-col gap-2 justify-end w-fit">
          <div class="bg-surface-200 rounded-lg border border-surface-300 p-2 min-h-10 min-w-10 w-fit">{{startOfCode}}</div>
        </div>
        <div class="flex flex-col gap-2 justify-end flex-3">
          <label class="font-semibold mr-3">Project Number<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></label>
          <input type="text"
                 pInputText [ngModel]="endOfCode"
                 (ngModelChange)="updateLocalCode($event)"
                 class="flex-1"
                 placeholder="e.g. FI0034"
                 [disabled]="!unitSelected"
                 (keydown)="preventDash($event)"
          />
        </div>
        <div class="flex flex-col gap-2 justify-end flex-4">
          <label class="font-semibold">Project Name<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></label>
          <input type="text" pInputText [(ngModel)]="localData.name" [disabled]="!unitSelected" fluid/>
        </div>
      </div>
      <label class="font-semibold">Status</label>
      <div class="flex gap-2 items-center">
        <p-tag severity="secondary" rounded value="Inactive"  />
        <p-toggleswitch [(ngModel)]="localData.active" [disabled]="!unitSelected" />
        <p-tag severity="info" rounded value="Active"  />
      </div>
      <div class="w-full h-[1px] bg-surface-200"></div>
      <label class="font-semibold">Project Approvers</label>
      <p-autocomplete [formControl]="approverControl"
                      [dropdown]="true"
                      [suggestions]="filteredApprovers"
                      (completeMethod)="filterApprovers($event)"
                      (onSelect)="addApprover()"
                      optionLabel="name"
                      placeholder="Type/Select name to add..."
                      appendTo="body"
                      [disabled]="!unitSelected"
                      class="w-1/2"
                      size="small">
      </p-autocomplete>
      <p><i>These Project Approvers can only approve travel funding for this project.</i></p>
      <label class="font-semibold">Current Approvers</label>
      <div class="flex flex-wrap gap-4 max-w-[600px]">
        @for (approver of localData.approvers; let ii = $index; track approver.id) {
          <div class="flex gap-2 items-center">
            <span>{{approver.name}}</span>
            <icon-btn (click)="removeApprover(ii)" variant="close-red"></icon-btn>
          </div>
        } @empty {
          <div class="pl-1"><i>No approvers yet.</i></div>
        }
      </div>
    }
  </div>

  <div class="flex-1"></div>
  <div class="w-full h-[1px] bg-surface-200"></div>
  <div class="flex justify-end gap-2">
    <p-button
      size="small"
      label="Save"
      severity="primary"
      icon="fa-regular fa-save"
      [disabled]="!canSave"
      (click)="closeDialog(localData)"
    />
    <p-button
      size="small"
      label="Cancel"
      severity="danger"
      icon="fa-regular fa-cancel"
      (click)="closeDialog()"
    />
  </div>
</div>
